import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import { store } from "./store/store";

// Override console.error to filter out ResizeObserver errors
const originalConsoleError = console.error;
console.error = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && firstArg.includes('ResizeObserver loop')) {
    return;
  }
  if (firstArg instanceof Error && firstArg.message && firstArg.message.includes('ResizeObserver loop')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Override console.warn as well since some ResizeObserver errors might be warnings
const originalConsoleWarn = console.warn;
console.warn = (...args) => {
  const firstArg = args[0];
  if (typeof firstArg === 'string' && firstArg.includes('ResizeObserver loop')) {
    return;
  }
  if (firstArg instanceof Error && firstArg.message && firstArg.message.includes('ResizeObserver loop')) {
    return;
  }
  originalConsoleWarn.apply(console, args);
};

window.addEventListener('error', (e) => {
  const isResizeObserverError =
    (e.message && e.message.includes('ResizeObserver loop')) ||
    (e.error && e.error.message && e.error.message.includes('ResizeObserver loop'));
  if (isResizeObserverError) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
});

// Also handle unhandled promise rejections where ResizeObserver errors might appear
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.preventDefault();
    return;
  }
});

// Additional: Override the global error handler
const originalHandleError = window.onerror;
window.onerror = function(message, source, lineno, colno, error) {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) {
    return true; // Prevent default error handling
  }
  if (error && error.message && error.message.includes('ResizeObserver loop')) {
    return true; // Prevent default error handling
  }
  if (originalHandleError) {
    return originalHandleError(message, source, lineno, colno, error);
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <ThemeProvider theme={theme}> */}
    {/* <CssBaseline /> */}
    <Provider store={store}>
      <App />
    </Provider>
    {/* </ThemeProvider> */}
  </React.StrictMode>
);
